// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class RecoverFunding extends PerunMessage {
  @jsonMember(String) channelID: string;

  constructor(channelID: string) {
    super();
    this.channelID = channelID;
  }

  messageType(): MessageType {
    return RecoverFunding;
  }

  messageTypeName(): MessageTypeName {
    return "RecoverFunding";
  }
}
